export let footerData = {
  General: [
    "Sign Up",
    "Help Center",
    "About",
    "Press",
    "Blog",
    "Careers",
    "Developers",
  ],
  "Browse LinkedIn": [
    "Learning",
    "Jobs",
    "Salary",
    "Mobile",
    "Services",
    "Products",
  ],
  "Business Solution": ["Talent", "Marketing", "Sales", "Learning"],
  Directories: [
    "Members",
    "Jobs",
    "Companies",
    "Featured",
    "Learning",
    "Posts",
    "Articles",
    "Schools",
    "News",
    "News Letters",
    "Services",
    "Products",
    "Content Topics",
    "Advice",
  ],
};
